import xSvg from '@/assets/icons/x.svg';

interface XIconProps {
  className?: string;
}

export default function XIcon({ className = '' }: XIconProps) {
  return (
    <img
      src={xSvg}
      alt="X"
      className={className}
    />
  );
}
